import { useEffect, useState } from "react"
import useOrderPollingQuery from "./useOrderPollingQuery"

const PENDING_PLATFORM_ORDER_STORAGE_KEY =
  "order_id_for_order_type_platform_subscription"

function readPendingPlatformOrderIdFromStorage() {
  if (typeof window === "undefined") return null
  try {
    const raw = localStorage.getItem(PENDING_PLATFORM_ORDER_STORAGE_KEY)
    const id = parseInt(raw, 10)
    return id || null
  } catch {
    return null
  }
}

export default function usePendingPlatformOrderPolling(isEnabled = true) {
  const [pendingPlatformOrderId, setPendingPlatformOrderId] = useState(null)

  useEffect(() => {
    if (!isEnabled) {
      setPendingPlatformOrderId(null)
      return
    }
    setPendingPlatformOrderId(readPendingPlatformOrderIdFromStorage())
  }, [isEnabled])

  useOrderPollingQuery(pendingPlatformOrderId)
}
